import { Notifications, notifications } from '@mantine/notifications';
import { ReactNode } from 'react';
import { IconCheck, IconX, IconInfoCircle, IconAlertTriangle } from '@tabler/icons-react';

export interface NotificationProviderProps {
  children: ReactNode;
  position?: 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center';
  autoClose?: number;
  limit?: number;
}

export function NotificationProvider({
  children,
  position = 'top-right',
  autoClose = 5000,
  limit = 5,
}: NotificationProviderProps) {
  return (
    <>
      <Notifications position={position} autoClose={autoClose} limit={limit} />
      {children}
    </>
  );
}

// Notification helper functions
export const notify = {
  success: (title: string, message?: string) => {
    notifications.show({
      title,
      message,
      color: 'green',
      icon: <IconCheck size={18} />,
    });
  },

  error: (title: string, message?: string) => {
    notifications.show({
      title,
      message,
      color: 'red',
      icon: <IconX size={18} />,
    });
  },

  info: (title: string, message?: string) => {
    notifications.show({
      title,
      message,
      color: 'blue',
      icon: <IconInfoCircle size={18} />,
    });
  },

  warning: (title: string, message?: string) => {
    notifications.show({
      title,
      message,
      color: 'yellow',
      icon: <IconAlertTriangle size={18} />,
    });
  },

  loading: (id: string, title: string, message?: string) => {
    notifications.show({
      id,
      title,
      message,
      loading: true,
      autoClose: false,
      withCloseButton: false,
    });
  },

  update: (id: string, title: string, message?: string, success = true) => {
    notifications.update({
      id,
      title,
      message,
      color: success ? 'green' : 'red',
      icon: success ? <IconCheck size={18} /> : <IconX size={18} />,
      loading: false,
      autoClose: 3000,
    });
  },

  hide: (id: string) => {
    notifications.hide(id);
  },

  clean: () => {
    notifications.clean();
  },
};

export default NotificationProvider;
